import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES, BASE_VIEW_OPTIONS, SUPPLIER_BASE_VIEW_OPTIONS } from '../utils/DataConstants';
import { ATTENTION_DASHBOARD_CRUD_ACTION_CREATORS } from '../actions/attention_dashboard_actions';
import { nullSafeGetOrElse } from '../utils/DataAccessUtils';
import { setDefaultView } from '../actions/session_actions';

export const attentionDashboardsRestCrudThunksForBuyer = new RestCrudThunks(
	'attention_dashboards',
	'attention_dashboard',
	'attentinoDashboard',
	'attentionDashboards',
	ATTENTION_DASHBOARD_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'dashboard/'
);

export const attentionDashboardsRestCrudThunksForSupplier = new RestCrudThunks(
	'attention_dashboards',
	'attention_dashboard',
	'attentinoDashboard',
	'attentionDashboards',
	ATTENTION_DASHBOARD_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'dashboard/'
);

const normalizeDefaultView = (viewData, fullData, userType) => {
	if (fullData && fullData.defaultWorkOrderFilterViewId) {
		const baseViewOptions =
			userType === ROLE_TYPES.SUPPLIER ? SUPPLIER_BASE_VIEW_OPTIONS : BASE_VIEW_OPTIONS;
		const matchingBaseView = baseViewOptions.find(
			(view) => view.id === fullData.defaultWorkOrderFilterViewId
		);
		if (matchingBaseView) {
			return {
				...matchingBaseView,
				isPinned: true,
			};
		}
	}
	return {
		...viewData,
		isPinned: true,
	};
};

export const getAttentionDashboard = (dispatch, userType) => {
	return new Promise((resolve, reject) => {
		dispatch(
			userType === ROLE_TYPES.SUPPLIER
				? attentionDashboardsRestCrudThunksForSupplier.readOne('default')
				: attentionDashboardsRestCrudThunksForBuyer.readOne('default')
		)
			.then((data) => {
				const normalizedView = normalizeDefaultView(
					nullSafeGetOrElse('defaultWorkOrderFilterView', data, {}),
					data,
					userType
				);
				dispatch(setDefaultView(normalizedView));
				resolve(normalizedView);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const updateAttentionDashboard = (dispatch, userType, entity) => {
	return new Promise((resolve, reject) => {
		dispatch(
			userType === ROLE_TYPES.SUPPLIER
				? attentionDashboardsRestCrudThunksForSupplier.update(entity)
				: attentionDashboardsRestCrudThunksForBuyer.update(entity)
		)
			.then((data) => {
				const normalizedView = normalizeDefaultView(
					nullSafeGetOrElse('defaultWorkOrderFilterView', data, {}),
					data,
					userType
				);
				dispatch(setDefaultView(normalizedView));
				resolve(normalizedView);
			})
			.catch((err) => {
				reject(err);
			});
	});
};
